import { render } from "./ProgrammaLavoro.vue?vue&type=template&id=5be63fe2&scoped=true&ts=true"
import script from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"
export * from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"

import "./ProgrammaLavoro.vue?vue&type=style&index=0&id=5be63fe2&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1770288832097110005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be63fe2"]])

export default __exports__